const MIME_TYPE_BY_EXTENSION: Record<string, string> = {
  pdf: 'application/pdf',
  png: 'image/png',
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
  webp: 'image/webp',
  gif: 'image/gif',
  heic: 'image/heic',
  heif: 'image/heif',
  heics: 'image/heic-sequence',
};

/** Last path segment + extension, e.g. `cars/id/foo.HEIC` → `image/heic` */
export const inferMimeTypeFromFileName = (name: string | undefined): string | undefined => {
  if (!name) return undefined;
  const base = name.split('/').pop() ?? name;
  const extension = base.split('.').pop()?.toLowerCase();
  if (!extension || extension === base.toLowerCase()) return undefined;

  return MIME_TYPE_BY_EXTENSION[extension];
};
